export default __webpack_public_path__ + "static/media/1.bef7d36b.png";